import { Text } from './text';
import { DefaultImages } from '@ifit/img/out/defaults';

type MarketingItem = {
  cardSize: string;
  deepLink: {
    url: string;
    text: string;
  };
  description: string;
  icon: string;
  id: string;
  imageUrl: string;
  title: string;
  type: string;
};

export function getFallbackMarketingItems(): MarketingItem[] {
  return [getFallbackMyListMarketingItem()];
}

export function getFallbackMyListMarketingItem(): MarketingItem {
  return {
    id: '',
    cardSize: 'small',
    type: 'marketing',
    title: Text.marketingItemTitle,
    description: Text.marketingItemDescription,
    icon: '',
    deepLink: {
      url: 'https://www.ifit.com/library',
      text: '',
    },
    imageUrl: DefaultImages.Source,
  };
}
